"use client";

import { LocaleType, usePathname, useRouter } from "@/i18n/routing";
import { useSearchParams } from "next/navigation";
import { useLocale } from "next-intl";
import { Button, TitleHeading } from "@habacuscode/habacus_ui_component_library";

type Props = {
    className?: string;
    disabled?: boolean;
    ariaLabel?: string;
};

export default function LanguageSwitcher({
    className = "",
    disabled = false,
    ariaLabel,
}: Readonly<Props>) {
    const pathname = usePathname();
    const searchParams = useSearchParams();
    const router = useRouter();
    const locale = useLocale();

    const isIt = locale === "it";
    const nextLocale: LocaleType = isIt ? "en" : "it";

    const qs = searchParams.toString();
    const href = qs ? `${pathname}?${qs}` : pathname;

    const computedAriaLabel =
        ariaLabel ?? (isIt ? "Passa alla lingua inglese" : "Switch to Italian");

    const switchLanguage = () => {
        if (disabled) return;
        router.replace(href, { locale: nextLocale });
    };

    return (
        <div className={["inline-flex items-center", className].join(" ")}>
            <Button
                name="language-switcher"
                onClick={switchLanguage}
                aria-label={computedAriaLabel}
                disabled={disabled}
                title={computedAriaLabel}
                variant="ghost"
            >
                <TitleHeading
                    label={isIt ? "IT" : "EN"}
                    size="span"
                    className="text-md font-bold"
                />
            </Button>
        </div>
    );
}
